import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function NewTaipeiAreaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🎯 Local SEO Optimization - 強化長尾關鍵字
  useSEO({
    title: '新北市搬家公司推薦2025｜板橋新莊中和永和搬家費用價格｜新北搬家多少錢｜24小時服務 0978-900-081',
    description: '新北市搬家公司推薦首選！建鈞精緻搬家服務新北市29區（板橋、新莊、中和、永和、三重、蘆洲、土城、汐止、新店、淡水等），提供套房搬家3000元起、家庭搬遷、辦公室搬遷。深耕新北多年，4.8分高評價156則好評，透明收費無隱藏費用，老公寓樓梯搬運專業，學生搬家優惠。免費估價：0978-900-081',
    keywords: '新北搬家,新北市搬家公司,新北搬家推薦,新北搬家費用,新北搬家價格,板橋搬家,新莊搬家,中和搬家,永和搬家,三重搬家,蘆洲搬家,土城搬家,汐止搬家,新店搬家,淡水搬家,新北搬家公司推薦,新北專業搬家,新北搬家多少錢,新北搬家推薦ptt,新北學生搬家,新北套房搬家,新北老公寓搬家,新北搬家便宜,新北搬家評價,新北24小時搬家,板橋搬家推薦,新莊搬家公司',
    ogType: 'website',
    ogImage: 'https://public.readdy.ai/ai/img_res/ed32dc45d2f47115147579014e7b5262.jpg'
  });

  // 🎯 Schema.org LocalBusiness Structured Data
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "建鈞精緻搬家 - 新北市搬家服務",
      "image": "https://readdy.ai/api/search-image?query=New%20Taipei%20City%20urban%20landscape%20with%20modern%20apartment%20buildings%20and%20residential%20areas%2C%20vibrant%20cityscape%20with%20organized%20neighborhoods%20and%20clear%20blue%20sky%2C%20professional%20moving%20services%20concept&width=1200&height=630&seq=newtaipei-schema&orientation=landscape",
      "@id": "https://www.example.com/area/new-taipei",
      "url": "https://www.example.com/area/new-taipei",
      "telephone": "0978-900-081",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "新北市",
        "addressRegion": "新北市",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 25.0169,
        "longitude": 121.4627
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://line.me/ti/p/@285yavdh"
      ],
      "areaServed": [
        "板橋區", "新莊區", "中和區", "永和區", "土城區", "三重區", "蘆洲區", 
        "汐止區", "新店區", "淡水區", "林口區", "三峽區", "樹林區", "鶯歌區",
        "泰山區", "五股區", "八里區", "萬里區", "金山區", "瑞芳區", "平溪區",
        "雙溪區", "貢寮區", "石門區", "石碇區", "深坑區", "烏來區"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "156"
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const districts = [
    { name: '板橋區', features: '新北市政府所在地，高樓大廈林立', tips: '電梯預約、停車位申請很重要', popular: true },
    { name: '新莊區', features: '副都心發展快速，新舊社區並存', tips: '注意社區管理規定', popular: true },
    { name: '中和區', features: '人口密集，住宅區為主', tips: '避開尖峰時段，交通較順暢', popular: true },
    { name: '永和區', features: '緊鄰台北市，生活機能佳', tips: '巷弄狹窄，需確認車輛通行', popular: true },
    { name: '土城區', features: '工業區與住宅區混合', tips: '部分區域坡度大，搬運較費力' },
    { name: '三重區', features: '傳統住宅區，老舊公寓多', tips: '樓梯搬運需更多人力' },
    { name: '蘆洲區', features: '捷運通車後發展迅速', tips: '新舊社區規定不同，需確認' },
    { name: '汐止區', features: '山區地形，社區大樓多', tips: '山路崎嶇，雨天需特別注意' },
    { name: '新店區', features: '山區與平地並存', tips: '山區道路狹窄，需小型車輛' },
    { name: '淡水區', features: '觀光區，透天厝與大樓並存', tips: '距離較遠，運輸時間較長' },
    { name: '林口區', features: '新興重劃區，社區規劃完善', tips: '風勢大，搬運需注意固定' },
    { name: '三峽區', features: '老街觀光區，透天厝多', tips: '巷弄狹窄，大型車輛難進入' }
  ];

  const advantages = [
    { icon: 'ri-map-pin-user-line', title: '熟悉新北各區', desc: '深耕新北市多年，了解各區道路和社區特性' },
    { icon: 'ri-team-line', title: '專業搬運團隊', desc: '經驗豐富的搬家師傅，處理各種搬運挑戰' },
    { icon: 'ri-shield-check-line', title: '完整保險保障', desc: '投保責任險，保障您的物品安全' },
    { icon: 'ri-price-tag-3-line', title: '透明收費標準', desc: '現場估價，絕無隱藏費用' }
  ];

  const faqData = [
    {
      question: '新北市搬家公司推薦哪一家？板橋新莊中和哪家好？',
      answer: '建鈞精緻搬家服務新北市 29 個行政區，擁有 4.8 分高評價和 156 則客戶好評，提供 24 小時免費估價服務。我們深耕新北多年，熟悉各區道路和社區特性，從板橋到淡水、從新莊到三峽都有豐富的搬家經驗。板橋、新莊、中和、永和是我們服務最頻繁的區域，累積超過千件成功案例。'
    },
    {
      question: '新北搬家費用怎麼算？2025年價格多少？',
      answer: '2025年新北市搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），兩房家庭搬家 6,000-8,000 元，三房搬家 10,000-15,000 元，辦公室搬遷 5,000-20,000 元。無電梯老公寓每層加收 500 元，跨區搬家（如淡水到板橋）另計距離費。我們提供免費現場估價，確保報價準確透明，絕無隱藏費用。'
    },
    {
      question: '新北搬家當天可以預約嗎？急件怎麼辦？',
      answer: '建議提前 3-7 天預約，讓我們有充足時間安排專業團隊和車輛。旺季（週末、月底、6-8月）建議提前 2 週預約。如有急件需求（當天或隔天搬家），可來電 0978-900-081 詢問當天是否有空檔，我們會盡力配合您的時間。板橋、新莊等熱門區域建議提早預約。'
    },
    {
      question: '新北市哪些區域搬家比較困難？山區怎麼搬？',
      answer: '山區地形如汐止、新店、淡水部分區域，道路較狹窄且坡度大，需要使用小型車輛，搬運時間較長。老舊社區如三重、蘆洲的老公寓，樓梯搬運需要更多人力（3-4位師傅）。林口因風勢大，搬運時需特別注意物品固定。我們團隊經驗豐富，這些困難區域都能妥善處理，山區搬家會安排熟悉路況的師傅。'
    },
    {
      question: '新北搬家需要申請停車證嗎？板橋新莊怎麼申請？',
      answer: '大部分新北市社區大樓都需要提前向管委會申請搬家許可和停車位。申請方式：1. 社區大樓向管委會申請（提前 3-7 天）；2. 路邊停車向區公所申請臨時停車證；3. 需提供搬家日期、車牌號碼、停車位置。板橋、新莊等市區停車較困難，建議一定要申請。我們會協助您完成這些準備工作，確保搬家順利進行。'
    },
    {
      question: '新北搬家什麼時間最便宜？學生搬家有優惠嗎？',
      answer: '平日（週一至週五）和非月底時段價格較優惠，可省 10-20%。避開搬家旺季（6-8月、12月）和週末，可享有更好的價格。學生搬家我們提供優惠方案，套房搬遷 2,500 元起，提供學生證可享額外折扣。我們也提供夜間搬家服務（晚上 8 點後），配合您的時間需求，歡迎來電詢問優惠方案。'
    },
    {
      question: '板橋搬家到台北要多久？跨區搬家費用怎麼算？',
      answer: '板橋到台北市區車程約 20-40 分鐘（依交通狀況），一般兩房搬家含打包、搬運、定位，全程約需 4-6 小時。跨區搬家費用包含：基本搬運費 + 距離費（每公里約 50-100 元）+ 樓層費（無電梯）。板橋到台北兩房搬家約 8,000-12,000 元。我們提供免費現場估價，給您最準確的報價。'
    },
    {
      question: '新北淡水、林口、三峽搬家會加價嗎？',
      answer: '淡水、林口、三峽等較遠區域，因距離和路況因素，會酌收距離費。淡水因距離較遠（距板橋約 25 公里），運輸時間較長；林口因風勢大，搬運需特別注意；三峽老街區巷弄狹窄，需使用小型車輛。實際費用依起點和終點位置而定，建議先預約免費現場估價，我們會提供最合理的報價。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=New%20Taipei%20City%20urban%20landscape%20with%20modern%20apartment%20buildings%20and%20residential%20areas%2C%20vibrant%20cityscape%20with%20organized%20neighborhoods%20and%20clear%20blue%20sky%2C%20professional%20moving%20services%20concept&width=1920&height=500&seq=newtaipei001&orientation=landscape"
            alt="新北市搬家服務"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">新北市搬家服務</h1>
          <p className="text-xl mb-8 leading-relaxed">
            服務新北市29個行政區，從板橋到淡水，從新莊到三峽<br />
            提供最專業、最貼心的新北搬家服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081" 
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              立即致電：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* 新北市各區搬家服務 */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">新北市各區搬家服務</h2>
            <p className="text-xl text-gray-600">涵蓋新北市29個行政區，提供在地化搬家服務</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {districts.map((district, index) => (
              <div 
                key={index} 
                className={`bg-gradient-to-br ${district.popular ? 'from-teal-50 to-white border-teal-200' : 'from-gray-50 to-white border-gray-200'} p-6 rounded-xl border hover:shadow-lg transition-shadow cursor-pointer`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-12 h-12 ${district.popular ? 'bg-teal-500' : 'bg-gray-600'} rounded-lg flex items-center justify-center`}>
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{district.name}</h3>
                    {district.popular && (
                      <span className="text-xs bg-teal-500 text-white px-2 py-1 rounded-full">熱門區域</span>
                    )}
                  </div>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">區域特色</p>
                    <p className="text-gray-700">{district.features}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">搬家建議</p>
                    <p className="text-teal-600 font-medium">{district.tips}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-6">
              除了以上區域，我們也服務：樹林、鶯歌、五股、泰山、八里、瑞芳、雙溪、貢寮、平溪、深坑、石碇、坪林、烏來等區域
            </p>
            <Link to="/service-area" className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
              查看完整服務區域
            </Link>
          </div>
        </div>
      </section>

      {/* 新北搬家優勢 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">選擇我們的理由</h2>
            <p className="text-xl text-gray-600">專業新北搬家服務，值得您的信賴</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600">{advantage.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 新北搬家常見問題（口語化） */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">新北搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多人問的新北搬家問題，一次解答</p>
          </div>

          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-question-line text-teal-500"></i>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/faq" 
              className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* 相關文章 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">新北搬家知識</h2>
            <p className="text-xl text-gray-600">更多實用的搬家資訊</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/knowledge/article/10" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=New%20Taipei%20City%20urban%20landscape%20with%20moving%20truck%20navigating%20through%20residential%20areas%2C%20modern%20apartment%20buildings%20and%20organized%20neighborhood%20streets&width=600&height=400&seq=move010&orientation=landscape"
                    alt="新北搬家服務指南"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    新北搬家服務指南：新北市各區搬家注意事項
                  </h3>
                  <p className="text-gray-600 mb-4">詳細介紹新北市各區的搬家特性和建議</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>7分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/8" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20highway%20with%20cityscape%20in%20background%2C%20professional%20logistics%20and%20transportation%20concept%2C%20clean%20modern%20style%20with%20blue%20sky&width=600&height=400&seq=move008&orientation=landscape"
                    alt="跨縣市搬家"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    跨縣市搬家注意事項
                  </h3>
                  <p className="text-gray-600 mb-4">長途搬家的完整規劃和準備</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>8分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/9" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20moving%20company%20team%20with%20branded%20truck%20and%20equipment%20in%20Taipei%20city%2C%20modern%20urban%20setting%20with%20organized%20moving%20supplies%20and%20friendly%20staff%20members&width=600&height=400&seq=move009&orientation=landscape"
                    alt="選擇搬家公司"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    如何選擇專業搬家服務
                  </h3>
                  <p className="text-gray-600 mb-4">選擇可靠搬家公司的完整指南</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>6分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">需要新北搬家服務？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            服務新北市29個行政區，熟悉各區道路和社區特性<br />
            專業團隊、透明收費、服務貼心
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
